import React from 'react';
import PropTypes from 'prop-types';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Email from 'services/data/email';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';
import { RoundLoader } from 'components/widgets/state-indicators/loader';


export default class SendToInbox extends React.Component {
  static propTypes = {
    emailId: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {};
    this.sendToInbox = this.sendToInbox.bind(this);
  }

  sendToInbox() {
    const { emailId, currentUser } = this.props;
    this.setState({ sendingToInbox: true, sentToInbox: false });

    Email.sendToInbox(emailId, currentUser.id)
      .then(() => {
        this.setState({ sendingToInbox: false, sentToInbox: true });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { sendingToInbox, sentToInbox } = this.state;

    return (
      <Tooltip title="Send to inbox" onClick={this.sendToInbox} className="send-to-inbox-wrapper">
        { (!sendingToInbox && !sentToInbox) &&
          <SVG src="svg/send-to-inbox.svg" className="send-to-inbox" />
        }
        { (sendingToInbox && !sentToInbox) &&
          <RoundLoader color={'#ddd'} className="send-to-inbox-loader" />
        }
        { (sentToInbox && !sendingToInbox) &&
          <SVG src="svg/check.svg" className="action-complete" />
        }
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/send-to-inbox.js